<!-- Notifications toggle -->
<button
    #notificationsOrigin
    matTooltip="Benachrichtigungen"
    (click)="openPanel()"
    mat-icon-button>
    <ng-container *ngIf="this.unreadNotificationsCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
            <span
                class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-red-600 text-indigo-50 text-xs font-medium">
                {{ this.unreadNotificationsCount }}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

    <div [@slideInRight]="{ value: '*', params: { timings: '0.5s ease-out' } }"
         class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-90 sm:w-90 sm:rounded-2xl overflow-hidden shadow-lg">

        <!-- Header -->
        <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
            <div class="sm:hidden -ml-1 mr-3">
                <button (click)="closePanel()" mat-icon-button>
                    <mat-icon [svgIcon]="'heroicons_solid:x'" class="icon-size-5 text-current"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Benachrichtigungen</div>
            <div class="ml-auto">
                <!-- Web push: enable / active / blocked -->
                <ng-container *ngIf="pushNotifications.canEnable()">
                    <button
                        (click)="enablePush()"
                        [disabled]="pushNotifications.busy()"
                        [matTooltip]="'Push-Benachrichtigungen auf diesem Gerät aktivieren'"
                        mat-icon-button>
                        <mat-icon class="icon-size-5 text-current">notification_add</mat-icon>
                    </button>
                </ng-container>
                <ng-container *ngIf="pushNotifications.enabled()">
                    <button
                        (click)="disablePush()"
                        [matTooltip]="'Push-Benachrichtigungen sind auf diesem Gerät aktiv – klicken zum Deaktivieren'"
                        mat-icon-button>
                        <mat-icon class="icon-size-5 text-current">notifications_active</mat-icon>
                    </button>
                </ng-container>
                <ng-container *ngIf="pushNotifications.blocked()">
                    <button
                        [matTooltip]="'Push-Benachrichtigungen sind im Browser blockiert. Bitte in den Website-Einstellungen des Browsers erlauben.'"
                        mat-icon-button>
                        <mat-icon class="icon-size-5 text-current">notifications_off</mat-icon>
                    </button>
                </ng-container>
                <ng-container *ngIf="pushNotifications.requiresInstall()">
                    <button
                        (click)="pushNotifications.showInstallInstructions()"
                        [matTooltip]="'Für Push auf dem iPhone/iPad: über „Teilen“ zum Home-Bildschirm hinzufügen'"
                        mat-icon-button>
                        <mat-icon class="icon-size-5 text-current">ios_share</mat-icon>
                    </button>
                </ng-container>
                <button
                    (click)="markAllAsRead()"
                    [disabled]="this.unreadNotificationsCount === 0 || this.markingAllAsRead"
                    [matTooltip]="'Alle als gelesen markieren'"
                    mat-icon-button>
                    <mat-icon *ngIf=!this.markingAllAsRead @zoomIn @zoomOut
                              [svgIcon]="'heroicons_solid:mail-open'"
                              class="icon-size-5 text-current"></mat-icon>
                    <mat-progress-spinner @zoomIn @zoomOut
                                          *ngIf=this.markingAllAsRead
                                          [diameter]="24"
                                          [mode]="'indeterminate'"></mat-progress-spinner>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="w-full relative flex flex-col flex-auto sm:max-h-120 divide-y overflow-y-auto bg-card">

            <!-- Notifications -->
            <ng-container *ngFor="let notification of notifications; trackBy: trackByFn">
                <div [@slideOutRight]="{ value: '*', params: { timings: '0.5s ease-out' } }"
                     class="w-full flex space-x-5 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5 cursor-pointer"
                     (mouseenter)="showDoubleTicks = true" (mouseleave)="showDoubleTicks = false">

                    <!-- Notification -->
                    <ng-container *ngIf="notification.link">

                        <ng-container *ngIf="!notification.useRouter">
                            <div (click)="navigateToNotificationSource(notification)"
                                 class="w-full flex flex-row py-5 pl-6 ">
                                <!-- Icon -->
                                <ng-container *ngIf="notification.icon">
                                    <div
                                        class="flex shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full bg-gray-100 dark:bg-gray-700">
                                        <mat-icon [svgIcon]="notification?.icon" class="icon-size-5"></mat-icon>
                                    </div>
                                </ng-container>

                                <!-- Title, description & time -->
                                <div class="w-full flex flex-col flex-auto space-y-2">

                                    <!-- title -->
                                    <ng-container *ngIf="notification.title">
                                        <div [innerHTML]="notification.title" class="font-semibold"></div>
                                    </ng-container>

                                    <!-- content -->
                                    <ng-container *ngIf="notification.description">
                                        <div [innerHTML]="notification.description"
                                             class="w-60 text-ellipsis overflow-hidden truncate py-2"></div>
                                    </ng-container>

                                    <!-- date -->
                                    <div class="mt-2 text-sm leading-none text-secondary">
                                        {{ notification?.createdAt | toDate | date: "MMM d, y, h:mm:ss a" }}
                                    </div>

                                </div>
                            </div>
                        </ng-container>

                    </ng-container>

                    <!-- Actions -->
                    <div class="relative flex flex-col  py-7 pr-5 pl-2">

                        <!-- Indicator -->
                        <ng-container>
                            <div class="relative flex">
                                <span *ngIf="!showDoubleTicks"
                                      class="absolute right-2 w-2 h-2 rounded-full bg-primary"></span>

                                <mat-icon (click)="markAsRead(notification)" *ngIf="showDoubleTicks"
                                          class="absolute right-1 -top-2 w-2 h-2 p-1 rounded-full hover:text-primary hover:bg-indigo-700 hover:bg-opacity-5 duration-1000">
                                    done_all
                                </mat-icon>

                            </div>

                        </ng-container>

                    </div>

                </div>


            </ng-container>

            <!-- No notifications -->
            <ng-container *ngIf="!notifications || !notifications.length">
                <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                        <mat-icon
                            [svgIcon]="'heroicons_outline:bell'"
                            class="text-primary-500-700"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">Keine Benachrichtigungen</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">Wenn neue Benachrichtigungen
                        vorhanden sind, erscheinen sie hier.
                    </div>
                </div>
            </ng-container>

        </div>

        <!-- footer -->
        <div class="w-full flex items-center justify-center border-t-2 bg-slate-50">
            <div (click)="goToNotifications()" class="flex justify-center text-center p-6 text-primary cursor-pointer">
                <span class="underline">Mehr anzeigen</span>
            </div>
        </div>

    </div>

</ng-template>
